import { Course } from "../model/course";
import { Video } from "../model/module";

// Current assumption on frontend is that lines in the article are linebreaks according to windows line breaks (\r\n) instead of mac or linux (\n)
// so we need to ensure all data is uploaded using that linebreak format for new paragraphs from \n\n to -> \r\n\r\n
export const lineBreakModifier = (course: Course): [Course, boolean] => {
    for (let session of course.sessions) {
        for (let module of session.contentModules) {
            switch (module.type) {
                case "video": 
                    let video = module as Video
                    if (video?.articleText) {
                        video.articleText = video.articleText.replaceAll("\n\n", "\r\n\r\n")

                        module = {...video}
                        break;
                    }
            }
        }
    }

    return [course, true]
}